// extracted by mini-css-extract-plugin
export default {"container":"SectionLayout_container__i3dH5"};